module.exports = __webpack_public_path__ + "img/PL08042.199d61bc.png";